module.exports = __webpack_public_path__ + "img/addIconWhite.60a3ae56.svg";